import { GEORESTRICTED_BANNER_HEIGHT } from '@/constants/shared';
import { useCompliance } from '@/hooks/useCompliance';
import { Box, Icon, Link, Text } from '@chakra-ui/react';
import { IoMdArrowForward } from 'react-icons/io';

export const GeocomplianceBanner = () => {
  const { geoCompliance } = useCompliance();
  if (!geoCompliance?.restrictAccess) {
    return null;
  }
  return (
    <Box
      p={3}
      h={GEORESTRICTED_BANNER_HEIGHT}
      textAlign="center"
      position="fixed"
      top={0}
      left={0}
      right={0}
      bgColor="#FFD7D0"
      zIndex="max"
      fontWeight="500"
    >
      <Text color="#922100" fontSize="sm" fontWeight="700">
        Plume services are not available in your region
      </Text>
      <Text color="#111111" fontSize="sm" fontWeight="500">
        🇺🇸 Join the cause to safeguard the future of crypto in America{' '}
        <Link
          href="https://www.standwithcrypto.org/action/sign-up?utm_source=plume"
          target="_blank"
          rel="noopener noreferrer"
          textDecoration="underline"
        >
          here
          <Icon as={IoMdArrowForward} transform="rotate(-45deg)" />
        </Link>
      </Text>
    </Box>
  );
};
